import ContractsTaxiForwardingContractListResponse, {
  ContractsTaxiForwardingContractListResponseItemModel,
  ContractsTaxiForwardingContractListResponseItemTaxiCorporation,
  ContractsTaxiForwardingContractListResponseItem,
} from "../../../../api/raily/contracts/taxi-forwarding/list/contracts-taxi-forwarding-contract-list.response";
import BillingModel from "../../../../types/billing-model";
import DateRange from "../../../../types/date-range";
import ContractsTaxiForwardingContractList, {
  ContractsTaxiForwardingContractListItem,
  ContractsTaxiForwardingContractListItemTaxiCorporation,
} from "./contracts-taxi-forwarding-contract-list";

const createBillingModel = (
  responseModel: ContractsTaxiForwardingContractListResponseItemModel,
) => {
  switch (responseModel) {
    case ContractsTaxiForwardingContractListResponseItemModel.AB:
      return BillingModel.AB;
    case ContractsTaxiForwardingContractListResponseItemModel.ABA:
      return BillingModel.ABA;
    case ContractsTaxiForwardingContractListResponseItemModel.OTHER:
      return BillingModel.OTHER;
    case ContractsTaxiForwardingContractListResponseItemModel.SABS:
      return BillingModel.SABS;
  }
};

const createTaxiCorporation = (
  responseTaxiCorporation: ContractsTaxiForwardingContractListResponseItemTaxiCorporation,
): ContractsTaxiForwardingContractListItemTaxiCorporation => {
  return {
    name: responseTaxiCorporation.companyName,
  };
};

const createDataItemDateRange = (
  item: ContractsTaxiForwardingContractListResponseItem,
): DateRange => {
  return {
    from: item.validSince,
    to: item.validTo,
  };
};

const createDataItem = (
  responseDataItem: ContractsTaxiForwardingContractListResponseItem,
): ContractsTaxiForwardingContractListItem => {
  return {
    periodOfValidity: createDataItemDateRange(responseDataItem),
    isActive: !responseDataItem.disabled,
    billingModel: createBillingModel(responseDataItem.model),
    distanceRate: responseDataItem.distanceRate,
    stoppingRate: responseDataItem.haltingTimeRate,
    freeStoppingPeriodMinutes: responseDataItem.haltingTimeAfterMinutes,
    uuid: responseDataItem.id,
    producerTaxi: createTaxiCorporation(responseDataItem.producerTaxi),
    consumerTaxi: createTaxiCorporation(responseDataItem.consumerTaxi),
    displayName: responseDataItem.displayName,
    priority: responseDataItem.priority,
    isPartner: responseDataItem.isPartner,
  };
};

const createData = (
  responseData: ContractsTaxiForwardingContractListResponseItem[],
): ContractsTaxiForwardingContractListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: ContractsTaxiForwardingContractListResponse,
): ContractsTaxiForwardingContractList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const contractsTaxiForwardingContractListFactory = {
  create,
};

export default contractsTaxiForwardingContractListFactory;
